import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
@Component({ 
  selector: 'app-tenders-details',
  templateUrl: './tenders-details.component.html',
  styleUrls: ['./tenders-details.component.css']
}) 
export class TendersDetailsComponent implements OnInit { 
  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private encDec:EncryptDecryptService, public translate: TranslateService) { }
  
  tender_id: any;
  backend_url: any = environment.serviceURL;
  btncontent:any = `Search`;
  language:any = "";
  datetime:any = this.httpservice.currentDateTime();
  isArchive:any='';
  // sortmenu:any;
  ngOnInit(): void {  
    this.language = sessionStorage.getItem('locale');//dynamic
    document.title="Tender Details";
    let  params = this.encDec.decText(this.routerparam.snapshot.paramMap.get('tenderid'));
    let sp = params.split(":");
    this.tender_id = sp.length>0? sp[0]:'';
    this.isArchive =sp.length>=2? sp[1]:'';

 

   // console.log(this.isArchive);

    // console.clear();
    this.TenderZoneList();
    this.getTender(this.tender_id);
    this.getTenderDetailsList_(this.tender_id);
    
  }
 
  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }
  
  
 


  apirespons: any;
  tender_Details: any ={
    "type": "",
    "tenderNumber": "",
    "parentTenderId":"",
    "zone": "",
    "region": "",
    "category": "",
    "title": "",
    "titleInHindi": "",
    "publishDate": "",
    "publishTime": "",
    "closingDate": "",
    "closingTime": "",
    "sourceUrl": "",
    "uploadDocument": "",
    "description": "",
    "jsonOptTxtDetails": "",
    "id": "",
};
  getTender(tid:any) {
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],//{ "columnName": "VCHMENUNAME", "type": "asc" }
        "condition": [
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          // { "columnName": "tinActiveStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "TYPE", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value": tid, "joinoperator": "and" }
        ], 
        "viewParameters": ""
      }];
    this.httpservice.getTenderDetails(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.apirespons = response.body;
          let respData = this.apirespons.RESPONSE_DATA;
          let respToken = this.apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            if(response.result.sec_1.length > 0){
              this.tender_Details = response.result.sec_1[0];

              this.GetRegion(this.tender_Details.zone);
            }
          }
          
      }
    });
  }
  detailsapirespons:any;
  tender_details_list:any;
  Addendum_Details:any[]=[];
  has_Addendum_Details:boolean=false; 
  Corrigendum_Details:any[]=[];
  has_Corrigendum_Details:boolean=false;
  getTenderDetailsList_(tid:any) {
    let query:any=[];
    if(this.isArchive=='false'){
       query=[
        {columnName: 'ZONE_ID',operator: '=', value: environment.ZONE_ID,joinoperator: 'and'},
        { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
        { "columnName": "TYPE", "operator": "in", "value": "2,3", "joinoperator": "and" },
        { "columnName": "LINK_ID", "operator": "=", "value": tid, "joinoperator": "and" },
        {"rawQuery": `'${this.datetime.date} ${this.datetime.HM+':00'}' >= DATE_FORMAT(concat_ws(' ',SD.PUBLISH_DATE,SD.PUBLISH_TIME), '%Y-%m-%d %H:%i:%s') AND '${this.datetime.date} ${this.datetime.HM+':00'}' < DATE_FORMAT(concat_ws(' ',SD.VCHARCHIVEDATE,SD.ARCHIVE_TIME), '%Y-%m-%d %H:%i:%s')`}
      ];
    } else if(this.isArchive=='true'){
       query=[
        {columnName: 'ZONE_ID',operator: '=', value: environment.ZONE_ID,joinoperator: 'and'},
        { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
        { "columnName": "TYPE", "operator": "in", "value": "2,3", "joinoperator": "and" },
        { "columnName": "LINK_ID", "operator": "=", "value": tid, "joinoperator": "and" },
        {"rawQuery":`'${this.datetime.date} ${this.datetime.HM+':00'}' >= DATE_FORMAT(concat_ws(' ',SD.VCHARCHIVEDATE,SD.VCHARCHIVE_TIME), '%Y-%m-%d %H:%i:%s')`} 
        
      ];
    } else {
      query=[
        {columnName: 'ZONE_ID',operator: '=', value: environment.ZONE_ID,joinoperator: 'and'},
        { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
        { "columnName": "TYPE", "operator": "in", "value": "2,3", "joinoperator": "and" },
        { "columnName": "LINK_ID", "operator": "=", "value": tid, "joinoperator": "and" },
        {"rawQuery": `'${this.datetime.date} ${this.datetime.HM+':00'}' >= DATE_FORMAT(concat_ws(' ',SD.PUBLISH_DATE,SD.PUBLISH_TIME), '%Y-%m-%d %H:%i:%s') AND '${this.datetime.date} ${this.datetime.HM+':00'}' < DATE_FORMAT(concat_ws(' ',SD.VCHARCHIVEDATE,SD.ARCHIVE_TIME), '%Y-%m-%d %H:%i:%s')`}
      ];
    }
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [{ "columnName": "intId", "type": "DESC" }],
        "condition": query,
        "viewParameters": ""
      }];

     
    this.httpservice.getTenderDetailsList(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break; 
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.detailsapirespons = response.body;
          this.apirespons = response.body;
          let respData = this.apirespons.RESPONSE_DATA;
          let respToken = this.apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            if(response.result.sec_1.length > 0){
              this.tender_details_list =response.result.sec_1;
              let f = this.tender_details_list;
              //  console.log('tender details list',this.tender_details_list);
              for (let i = 0; i < f.length; i++) {
                if(f[i].type==2){
                  this.Addendum_Details.push(f[i]);
                } 
                else if(f[i].type==3){
                  this.Corrigendum_Details.push(f[i]);
                }
              }
              if(this.Addendum_Details.length > 0){
                this.has_Addendum_Details = true;
              }
              if(this.Corrigendum_Details.length > 0){
                this.has_Corrigendum_Details = true;
              } 
            }
          }
          
      }
    });
  }


 
  jsonConvert(data: any, type: any) {
    if(data==null || data==""){
      return "";
    }
    if(data.jsonOptTxtDetails=="" || data.jsonOptTxtDetails==null){
      return "";
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'ZONE_ID') {
      return d.ZONE_ID;
    } else if (type == 'LINK_ID') {
      return d.LINK_ID;
    } else if (type == 'REGION_ID') {
      return d.REGION_ID;
    } else {
      return '';
    }
  }

htmlTag(data:any){
  return this.encDec.decodeHtml(data);
}

encode(data:any){
  return btoa(data);
}

Files_:any = (data:any)=>{
  if(data==""){
    return []; 
  }
  if(data.length <= 0){
    return [];
  }
  var idlist = []; 
  var list = [];
  for (let i = 0; i < data.length; i++) {
    if(!this.arrayCheck(idlist,data[i].id)){
      if(data[i].fileType!==''){
        if(data[i].selectFIle_details.fileSize!==''){
          idlist.push(data[i].id);
          list.push(data[i]);
        }
      }  
    }  
  } 
  return list;
}
 
arrayCheck(arr:any[],key:any):boolean{
  if(arr.length <= 0){
    return false;
  }
  for (let i = 0; i < arr.length; i++) {
    if(arr[i]==key){
      return true;
    }
  }
  return false;
}





checkFileType(data:any):any{
  let ext:any,fileType:any;
  ext= ['webp','jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG','xlsx','xls','csv','docx','doc'];
  if(data==""){
    return false; 
  }
  if(data.selectFIle==""){
    return false; 
  }
  if(data.selectFIle_details==undefined){
    return false; 
  }
  if(data.selectFIle_details.fileType==undefined){
    return false; 
  }
  if(data.selectFIle_details.fileType==''){
    return false; 
  }
  fileType=data.selectFIle_details.fileType.toLowerCase();
  if(fileType=='xlsx' || fileType=='xls' || fileType=='csv'){
    return {'fileType':fileType,'file': `|| <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType} ||`}; 
  } else if(fileType=='docx' || fileType=='doc'){
    return {'fileType':fileType,'file':`|| <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType} ||`}; 
  } else if(fileType=='pdf'){
    return {'fileType':fileType,'file':`|| <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType} ||`}; 
  } else {
    return {'fileType':fileType,'file':`|| <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType} ||`}; 
  }

}

zone_apirespons: any;
zoneList: any[] = [];
TenderZoneList() { 
  this.httpservice.getZoneList().subscribe((response: HttpEvent<any>) => {
    switch (response.type) { 
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break;
      case HttpEventType.Response:
        this.zone_apirespons = response.body;
        let respData = this.zone_apirespons.RESPONSE_DATA;
        let respToken = this.zone_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let res = JSON.parse(Buffer.from(respData, 'base64').toString());
          this.zoneList = res.original.data;
         
        } 
    }
  });
} 
region_apirespons: any;
  regionList: any[] = [];
  GetRegion(val:any){
    
    this.regionList = [];
    let p = {'zone_id':val};
    if(val==""){
      return;
    }
    this.httpservice.GetRegionByZoneId(p).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.region_apirespons = response.body;
          let respData = this.region_apirespons.RESPONSE_DATA;
          let respToken = this.region_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.regionList = res.original.data;
           
          }
      }
    });
  }
 
getZoneNameEnHn(data: any):any {
  let list = this.zoneList;
  for(let item of list){
   
    if(item.int_Demographic_Id==data){
     
      if(this.language == "English"){
        return this.encDec.decodeHtml(item.vch_Demographic_Name);
      } else {
        return this.encDec.decodeHtml(item.vch_Demographic_Name_Hindi );
      }
    }
  }
}

getregionNameEnHn(data: any):any {
  let list = this.regionList;
  
  for(let item of list){
   
    if(item.int_Demographic_Id==data){
   
      if(this.language == "English"){
     
       return  this.encDec.decodeHtml(item.vch_Demographic_Name);
      } else {
       
         return this.encDec.decodeHtml(item.vch_Demographic_Name_Hindi);
      
      }
    }
  }
}


}
